import {AxiosError} from 'axios';

import {captureException} from '@zzng/common/utils/matrix';

import {
  RECOMMEND_CODES,
  RECOMMEND_CODES_USING_PAPAS,
  RecommendCode,
  RecommendCodeUsingPapas
} from '@/root/constants/recommendCode';

import {DicaronIssueAndHomeErrorCode} from '@/shared/constants/dicaronServerErrorCode';

export const isRecommendCode = (code: string): code is RecommendCode => {
  return RECOMMEND_CODES.includes(code as RecommendCode);
};

export const isRecommendCodeUsingPapas = (code: string): code is RecommendCodeUsingPapas => {
  return RECOMMEND_CODES_USING_PAPAS.includes(code as RecommendCodeUsingPapas);
};

export const getPapasErrorCode = (error: Error): DicaronIssueAndHomeErrorCode => {
  if (error instanceof AxiosError) {
    const responseErrorCode = error.response?.data.code;
    const isPapasError = Object.values(DicaronIssueAndHomeErrorCode).includes(
      responseErrorCode as DicaronIssueAndHomeErrorCode
    );
    if (isPapasError) {
      return responseErrorCode;
    } else {
      captureException(`정의되지 않은 파파스 에러 코드입니다. errorCode: ${responseErrorCode}`);
    }
  }

  return DicaronIssueAndHomeErrorCode.UNKNOWN;
};
